import { Component, HostBinding, Input } from '@angular/core';

/** Overlay loader inside .user-mgmt-card (does not shift table layout). */
@Component({
  selector: 'eview-user-mgmt-loader',
  template: `<eview-circular-loader></eview-circular-loader>`,
  styleUrls: ['./user-mgmt-loader.component.scss']
})
export class UserMgmtLoaderComponent {
  @Input() loading = false;

  @HostBinding('class.user-mgmt-loader--visible')
  get visible(): boolean {
    return this.loading;
  }
}
